import { Stack } from '@mui/material'
import { BaseWidget } from 'components/farm-dashboard/components/widgets/baseWidget'
import { useWidgetPsvDynamicChart } from 'components/farm-dashboard/hooks/useWidgetPsvDynamicChart'
import PsvWidgetChart from './сomponents/chart/PsvWidgetChart'
import PsvDynamicHeader from './сomponents/widget-header/PsvDynamicHeader'

export const PsvDynamicChart = () => {
	const { psvData } = useWidgetPsvDynamicChart()

	const timestamps = psvData.map(d => d.timestamp)
	const psvSeries = psvData.map(d => d.psv_value)
	const normSeries = psvData.map(d => d.norm_psv_value)
	const currentPsv = psvSeries.length ? psvSeries[psvSeries.length - 1] : 0
	const currentNorm = normSeries.length ? normSeries[normSeries.length - 1] : 0

	return (
		<BaseWidget
			title='Динамика ПСВ'
			path='analytics/feeding'
			pathLable='Перейти в аналитику кормления'
		>
			<Stack
				direction='row'
				justifyContent='space-between'
				alignItems='center'
				mb='12px'
			>
				<PsvDynamicHeader psv_value={currentPsv} norm_psv_value={currentNorm} />
			</Stack>

			<PsvWidgetChart
				timestamp={timestamps}
				psv_value={psvSeries}
				norm_psv_value={normSeries}
			/>
		</BaseWidget>
	)
}
